
import Vue from "vue";
import Notice from "~/entities/Notice";

export default Vue.extend({
  name: "PaymentMethod",
  data() {
    return {};
  },
  props: {
    method: {} as any | undefined,
    selected: { type: Boolean, default: false },
    mode: { type: String, default: "default" },
  },
  methods: {
    deattachPaymentMethod() {
      this.$emit("deattachPaymentMethod", this.method);
    },
    getBillingAddress(address) {
      return address.city + ", " + address.state + ", " + address.country;
    },
    formatDate(time) {
      let date = new Date(time);
      let formattedDate = date?.toLocaleDateString("en-us", {
        year: "numeric",
        weekday: "short",
        month: "short",
        day: "numeric",
        timeZone: "utc",
      });
      return formattedDate ? formattedDate : date;
    },
    selectPM() {
      this.$emit("selectPaymentMethod");
    },
  },
});
